import { createAsyncThunk } from '@reduxjs/toolkit'
import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { backendForFirebaseUser } from 'shared/api/backendForFirebaseUser'
import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'

export const fetchCardData = createAsyncThunk(
    'card/fetchCardData',
    async (collectionName) => {
        const backend = backendForFirebaseUser(getAuth(app).currentUser)
        if (backend) {
            if (collectionName === 'cards') {
                const result = await backend.getCards()
                return result.cards
            }
            if (collectionName === 'special') {
                const result = await backend.getSpecial()
                return result.special
            }
            throw new Error(`Unsupported card collection: ${collectionName}`)
        }

        const { collection, db, getDocs } = await loadLegacyFirestore()
        const querySnapshot = await getDocs(collection(db, collectionName))
        return querySnapshot.docs
            .map((document) => ({ ...document.data() }))
            .sort((a, b) => a.id - b.id)
    }
)
